import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Footer from "./Footer";

const OpenTicket = () => {
  const [formData, setFormData] = useState({
    userId: "",
    subject: "",
    description: "",
  });

  const apiKey = process.env.REACT_APP_API_KEY;
  const auth = getAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const key in formData) {
      if (!formData[key]) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please fill in all fields.",
        });
        return;
      }
    }

    const apiUrl = "https://api.v1.spotyourleads.com/user/openTicket";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Form submitted successfully!",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          setFormData({
            userId: formData.userId, // احتفظ بـ userId
            subject: "",
            description: "",
          });
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: result?.message || "Failed to submit the form. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while submitting the form.",
      });
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setFormData((prev) => ({ ...prev, userId: user.uid }));
      } else {
        navigate("/sign-in");
      }
    });

    return () => unsubscribe();
  }, [auth, navigate]);

  return (
    <>
      <Helmet>
        <title>Spot Your Leads | Open Ticket</title>
      </Helmet>
      <section className="homeFourth formSection account leads-form">
      <div className="pricing-title">
            <h2>Open Ticket</h2>
          </div>
        <Container>
          <Row>
            <Col lg={12}>
              <div className="formDiv">
               
                <form onSubmit={handleSubmit}>
                  <h3>Subject</h3>
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                  <br />
                  <h3>Message</h3>
                  <ReactQuill
                     style={{ backgroundColor:"#EDECED"}}

                    theme="snow"
                    value={formData.description}
                    onChange={(value) =>
                      setFormData((prev) => ({ ...prev, description: value }))
                    }
                  />
                  <button type="submit">Send</button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>

      </section>
      <Footer />
    </>
  );
};

export default OpenTicket;
